import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { CHeaderNav } from '@coreui/react';
import JobsViewPage from '../containers/JobsListPage';
import JobsUploadPage from '../containers/JobsUploadPage';
import BulkReviewPage from '../containers/BulkReviewPage';
import SearchForm from '../../app/SearchForm';

const JobsPage = () => {
  const match = useRouteMatch();
  const {
    enableSearchModule
  } = useFlags();
  return (
    <Switch>
      <Route path={`${match.url}/search/:query*`}>
        {
          enableSearchModule && (
            <CHeaderNav className="glympse-searchBar" >
              <SearchForm />
            </CHeaderNav>
          )
        }
        <JobsViewPage />
      </Route>
      <Route path={ `${match.url}/upload/:id`}>
        <BulkReviewPage />
      </Route>
      <Route path={ `${match.url}/upload`}>
        <JobsUploadPage />
      </Route>
    </Switch>
  );
};

export default JobsPage;
